import type { RouteLocationNormalizedLoaded, RouteLocationRaw } from 'vue-router'
import router from '@/router'

export function makeCoreUrl(path: string | string[]): string {
  let built: string

  if (typeof path === 'string') {
    built = path.replace(/^\/+/, '')
  } else {
    built = path.map(v => encodeURIComponent(v)).join('/')
  }

  return `${import.meta.env.VITE_CORE_URL}/${built}`
}


export function navigateTo(to: RouteLocationRaw) {
  return router.push(typeof to === 'string' ? { name: to } : to)
}

export function navigateToCoreUrl(...args: Parameters<typeof makeCoreUrl>) {
  window.location.href = makeCoreUrl(...args);
}
